<template>
  <div>
    <step-title
      title="Link one click buy"
      description="Ofereça um produto após a primeira compra, com um link one click buy"
    />
    <div class="w-100">
      <div
        class="p-3 my-7 border rounded border-information-400 bg-information-024"
      >
        <div class="d-flex gap-3">
          <bp-icon icon="fa fa-info-circle" class="text-information-500" />
          <span class="functional-1 text-information-700">
            O link deve ser inserido no código da página de obrigado da primeira
            compra do seu cliente.
          </span>
        </div>
      </div>

      <b-form-checkbox
        v-if="product"
        switch
        class="mr-5 text-switch"
        id="product-status"
        v-model="enable"
      >
        Ativar/Desativar One Click Buy
      </b-form-checkbox>

      <div v-if="loading" class="text-center my-9">
        <b-spinner variant="primary" />
      </div>

      <div
        v-else-if="enable && product.charge_type === 'recurrent'"
        class="mt-6"
      >
        <action-dispatcher
          action="plan/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <links-inputs
            v-for="(plan, i) in plans"
            :key="`plan-link-${i}`"
            :product="product"
            :label="plan.name"
            :custom_url="plan.oneclick_url"
          />
        </action-dispatcher>
      </div>

      <div
        v-else-if="enable && product.type_product === 'onsite_event'"
        class="mt-6"
      >
        <action-dispatcher
          action="events/getLots"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <links-inputs
            v-for="(link, i) in eventLinks"
            :key="`event-link-${i}`"
            :product="product"
            :label="link.label"
            :custom_url="link.oneclick_url"
          />
          <div
            v-if="eventLinks.length == 0"
            class="container centralize-row text-center pt-5 my-6 mt-9"
          >
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <img
                  class="d-block mb-5 mx-auto"
                  src="@/assets/images/home/welcome.svg"
                />
                <div class="mb-6">
                  <small>
                    Você ainda não tem ingressos cadastrados, clique no botão
                    abaixo e cadastre o primeiro
                  </small>
                </div>
                <router-link
                  class="btn btn-primary-500 btn-32 my-5 my-lg-0 text-decoration-none"
                  :to="{
                    name: 'event-new-lot',
                    params: {
                      id: $route.params.id
                    }
                  }"
                >
                  <div class="d-flex align-items-center">
                    <i class="fa-solid fa-plus mr-3" />
                    <div style="white-space: nowrap">
                      Cadastrar
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </action-dispatcher>
      </div>

      <div v-else-if="enable">
        <links-inputs
          :product="product"
          :custom_url="product.oneclick_url"
          label="Oferta Principal"
        />
        <action-dispatcher
          action="offer/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <h3 class="mt-9 mb-1">Links de ofertas</h3>
          <links-inputs
            v-for="(link, i) in offers"
            :key="`offer-link-${i}`"
            :product="product"
            :label="link.name"
            :custom_url="link.oneclick_url"
          />
        </action-dispatcher>
      </div>
    </div>
  </div>
</template>

<script>
import LinksInputs from "@/components/product/LinksInputs";
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  components: { LinksInputs },
  data() {
    let offer = "";
    if (this.$route.query.offer && this.$route.query.offer !== "padrao") {
      offer = this.$route.query.offer;
    }
    let plan = "";
    if (this.$route.query.plan && this.$route.query.plan !== "padrao") {
      plan = this.$route.query.plan;
    }
    return {
      loading: false,
      filters: {
        plan,
        offer,
        group: ""
      }
    };
  },
  computed: {
    ...mapState("membersGroups", ["groupsFilter"]),
    ...mapState("product", ["product"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("events", ["lots"]),
    enable: {
      get() {
        return (
          this.product &&
          (this.product.enable_oneclickbuy ||
            (this.loading && !this.product.enable_oneclickbuy))
        );
      },
      set(value) {
        this.loading = true;
        this.$store
          .dispatch("product/put", {
            id: this.product.id,
            enable_oneclickbuy: value
          })
          .catch(() => {
            this.$message.error(
              "Não foi possível ativar a funcionalidade One Click Buy"
            );
            this.enable = !value;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    plan() {
      return this.plans.find(plan => plan.id === this.filters.plan);
    },
    offer() {
      return this.offers.find(offer => offer.id === this.filters.offer);
    },
    group() {
      return this.groupsFilter.find(group => group.id === this.filters.group);
    },
    eventLinks() {
      return this.lots.map(t => ({ ...t, label: t.name }));
    }
  },
  watch: {
    "filters.offer"() {
      this.filters.group = null;
    },
    "filters.plan"() {
      this.filters.group = null;
    }
  }
};
</script>
